import { useMemo } from "react"
import * as yup from "yup"
import i18n from "@/i18n"

export const useUpdateReservationValidationSchema = ({ venue, currentTableId = null }) =>
  useMemo(
    () =>
      yup.object({
        peopleAmount: yup
          .number()
          .nullable()
          .transform((value, originalValue) => (originalValue === "" ? null : value))
          .min(1, i18n.t("app.forms.create_reservation.errors.people_amount_min"))
          .label(i18n.t("app.public.new_reservation.labels.people_amount")),
        startTime: yup.date().required(i18n.t("app.public.new_reservation.errors.start_time_required")),
        endTime: yup
          .date()
          .required(i18n.t("app.public.new_reservation.errors.end_time_required"))
          .test("is-greater", i18n.t("app.public.new_reservation.errors.end_time_too_early"), function (value) {
            return value > this.parent.startTime
          })
          .test("at-least-an-hour", i18n.t("app.public.new_reservation.errors.at_least_an_hour"), function (value) {
            return value.valueOf() - this.parent.startTime.valueOf() >= 60 * 60 * 1000
          }),
        tableId: yup
          .string()
          .oneOf(venue?.tables?.map((table) => table.id) || [], "")
          .label(i18n.t("app.public.new_reservation.labels.table"))
          .required(i18n.t("app.public.new_reservation.errors.table_required"))
          .test("not-deleted", i18n.t("app.forms.update_reservation.errors.table_deleted"), function (value) {
            const table = venue?.tables?.find((t) => t.id === value)
            if (!table) return false
            if (table.deleted && value !== currentTableId) return false
            return true
          }),
        note: yup.string().label(i18n.t("app.public.new_reservation.labels.note")),
      }),
    [i18n.locale, venue, currentTableId],
  )
